module.exports = __webpack_public_path__ + "img/sign-pad-bg-hk.8872b36a.png";